import { MinusCircleIcon, PencilSquareIcon, PlusCircleIcon, PrinterIcon, TrashIcon } from "@heroicons/react/24/outline";
import { useApplicationModals } from "app/common/hooks";
import {
  useCollector,
  usePaginatedCollector,
} from "app/integration/common/hooks";
import {
  BadgeButton,
  IconButton,
  ServerSidePaginationButtons,
} from "app/components/atoms/button";
import { SearchInput } from "app/components/atoms/input";
import Table from "app/components/atoms/table";
import Typography from "app/components/atoms/typography";
import ImageWithPreview from "app/components/molecules/imageWithPreview";
import MainLayout from "app/layouts/main";
import AppModals from "app/modals";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api, { productVariant } from "app/integration/api";
import { Badge } from "app/components/atoms/badge";

const breadcrumbItems = [
  { label: "Retur Customer", href: "#" },
];

function ReturCustomer() {
  const navigate = useNavigate();
  const { openModal, setPayloads } = useApplicationModals();
  const [expandedRows, setExpandedRows] = useState({});
  const [params, setParams] = useState({
    search: "",
    stock_opname_search: "",
    status: null,
    customer_id: null,
    page: 1,
    limit: 10,
  });

  useEffect(() => {
    collect(params);
  }, [params]);

  const [
    returCustomers,
    setReturCustomer,
    returCustomerLoader,
    collect,
    returCustomerPaginationProps,
  ] = usePaginatedCollector({ modelName: "returCustomer", params: params });

  const [salesOrders] = useCollector({ modelName: "salesOrder" });

  const [productVariants] = useCollector({ modelName: "productVariant" });

  return (
    <MainLayout
      activeSidebarNavigation="warehouse"
      activeSidebarChild="retur-customer"
      breadcrumbItems={breadcrumbItems}
      pageTitle="Retur Customer"
      headingButtons={[
        {
          label: "Tambah Retur Customer",
          type: "routerButton",
          to: "/retur-customer/create",
        },
        {
          label: "Export Retur Customer",
          type: "button",
          onClick: () => openModal("exportReturCustomerExcel"),
        },
      ]}
    >
      <AppModals
        items={["exportReturCustomerExcel"]}
        onSuccess={{
          "exportReturCustomerExcel": () => collect(),
        }}
      />
      <Table.Container>
        <Table.UtilitiesWrapper>
          <Table.SearchBarWrapper>
            <Table.SearchBarItemWrapper>
              <SearchInput testId="retur-customer-search-input"
                placeholder="Cari Retur Customer"
                type="text"
                value={params.search}
                onChange={(e) =>
                  setParams({ ...params, search: e.target.value })
                }
              />
            </Table.SearchBarItemWrapper>
          </Table.SearchBarWrapper>
        </Table.UtilitiesWrapper>
        <Table.Wrapper asIndex={false}>
          <Table.Header>
            <Table.HeaderRow>
              <Table.Heading></Table.Heading>
              <Table.Heading>Kode</Table.Heading>
              <Table.Heading>Sales Order</Table.Heading>
              <Table.Heading>Produk</Table.Heading>
              <Table.Heading>Produk Variant</Table.Heading>
              <Table.Heading>Jumlah</Table.Heading>
              <Table.Heading>Alasan</Table.Heading>
              <Table.Heading>Tanggal</Table.Heading>
              <Table.Heading>Status</Table.Heading>
            </Table.HeaderRow>
          </Table.Header>
          <Table.Body>
            {returCustomers?.map((returCustomer, key) => {
              const salesOrder = salesOrders?.find((item) => item.id === returCustomer.transaction_id);
              return (
                <>
                  <Table.BodyRow key={key}>
                    <Table.Cell>
                      {returCustomer?.product_code_list?.length > 0 && (
                        <IconButton testId="retur-customer-minus-circle-button"
                        icon={expandedRows[key] ? MinusCircleIcon : PlusCircleIcon}
                        onClick={(e) => {
                          setExpandedRows(prev => ({
                            ...prev,
                            [key]: !prev[key]
                          }));
                        }}
                      />
                      )}
                    </Table.Cell>
                    <Table.Cell>
                      {returCustomer?.code}
                    </Table.Cell>
                    <Table.Cell>
                      {salesOrder ? (
                        <span>{salesOrder.order_code || 'No code available'}</span>
                      ) : (
                        <span className="text-gray-400">No code available</span>
                      )}
                    </Table.Cell>
                    <Table.Cell>{productVariants?.find((item) => item.id === returCustomer?.product_variant_id)?.product_detail?.name}</Table.Cell>
                    <Table.Cell>{productVariants?.find((item) => item.id === returCustomer?.product_variant_id)?.color?.name}, {productVariants?.find((item) => item.id === returCustomer?.product_variant_id)?.size?.name}</Table.Cell>
                    <Table.Cell>
                      {parseInt(returCustomer?.qty)}
                    </Table.Cell>
                    <Table.Cell>
                      {returCustomer?.reason}
                    </Table.Cell>
                    <Table.Cell>
                      <Typography.Date date={returCustomer?.createdAt} format="dd MMMM yyyy hh:mm:ss" />
                    </Table.Cell>
                    <Table.Cell>
                      <Badge color={returCustomer?.status === "pending" ? "yellow" : returCustomer?.status === "approved" ? "green" : "red"}>{returCustomer?.status}</Badge>
                    </Table.Cell>
                    <Table.Cell>
                      <div className="flex gap-1 items-center">
                        {/* <IconButton testId="retur-customer-pencil-square-button"
                        icon={PencilSquareIcon}
                        onClick={(e) => {
                          setPayloads("returCustomer.update", {
                            id: returCustomer.id,
                          });
                          openModal("returCustomer.update");
                        }}
                      />
                      <IconButton testId="retur-customer-trash-button"
                        icon={TrashIcon}
                        onClick={(e) => {
                          setPayloads("stockOpname.delete", {
                            id: stockOpname.id,
                          });
                          openModal("stockOpname.delete");
                        }}
                      /> */}
                      </div>
                    </Table.Cell>
                  </Table.BodyRow>
                  {
                    expandedRows[key] && returCustomer?.product_code_list?.length > 0 && (
                      <Table.BodyRow className="bg-gray-50">
                        <Table.Cell colSpan="9">
                          <div className="px-4 py-3">
                            <div className="flex items-center mb-3">
                              <h4 className="text-sm font-semibold text-gray-700 uppercase tracking-wider">Daftar Kode Produk</h4>
                              <span className="ml-2 px-2 py-0.5 text-xs font-medium bg-gray-100 text-gray-600 rounded-full">
                                {returCustomer.product_code_list.length} item
                              </span>
                            </div>
                            <div className="space-y-2">
                              {returCustomer.product_code_list.map((code, idx) => (
                                <div key={idx} className="group bg-white rounded-lg border border-gray-100 hover:border-blue-100 transition-colors duration-150 shadow-sm hover:shadow">
                                  <div className="p-3">
                                    <div className="flex items-start justify-between">
                                      <div className="flex-1 min-w-0">
                                        <div className="flex items-center space-x-2">
                                          <div className="bg-gray-50 px-3 py-1.5 rounded-md border border-gray-100">
                                            <span className="font-mono text-sm font-medium text-gray-800">{code.qr_code}</span>
                                          </div>
                                          <div className="flex-shrink-0">
                                            <Badge
                                              color={
                                                code.reason ? 'red' :
                                                  'gray'
                                              }
                                              className="px-2 py-1 text-xs font-medium"
                                            >
                                              {code.retur_reason || 'Tidak ada alasan'}
                                            </Badge>
                                          </div>
                                        </div>
                                        {code.description && (
                                          <p className="mt-2 text-sm text-gray-600">
                                            <span className="font-medium">Catatan: </span>
                                            {code.description}
                                          </p>
                                        )}
                                      </div>
                                      <div className="ml-2 flex-shrink-0 flex items-center">
                                        <span className="text-xs text-gray-400">
                                          {new Date(code.createdAt || new Date()).toLocaleDateString('id-ID', {
                                            day: '2-digit',
                                            month: 'short',
                                            year: 'numeric',
                                            hour: '2-digit',
                                            minute: '2-digit'
                                          })}
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              ))}
                            </div>
                          </div>
                        </Table.Cell>
                      </Table.BodyRow>
                    )
                  }
                </>
              );
            })}
          </Table.Body>
        </Table.Wrapper>
        <Table.PaginationWrapper>
          <ServerSidePaginationButtons
            paginationProps={returCustomerPaginationProps}
            params={params}
            setParams={setParams}
          />
        </Table.PaginationWrapper>
      </Table.Container>
    </MainLayout>
  );
}

export default ReturCustomer;
